var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3346 16.0003C29.3346 23.3641 23.3651 29.3337 16.0013 29.3337C8.63751 29.3337 2.66797 23.3641 2.66797 16.0003C2.66797 8.63653 8.63751 2.66699 16.0013 2.66699C23.3651 2.66699 29.3346 8.63653 29.3346 16.0003ZM11.7586 20.243C11.3681 19.8524 11.3681 19.2193 11.7586 18.8288L14.587 16.0003L11.7586 13.1719C11.3681 12.7814 11.3681 12.1482 11.7586 11.7577C12.1491 11.3672 12.7823 11.3672 13.1728 11.7577L16.0012 14.5861L18.8297 11.7577C19.2202 11.3672 19.8533 11.3672 20.2439 11.7577C20.6344 12.1482 20.6344 12.7814 20.2439 13.1719L17.4154 16.0003L20.2439 18.8288C20.6344 19.2193 20.6344 19.8524 20.2439 20.243C19.8533 20.6335 19.2202 20.6335 18.8297 20.243L16.0012 17.4145L13.1728 20.243C12.7823 20.6335 12.1491 20.6335 11.7586 20.243Z",
    fill: "#FC0202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.b78f27c1.svg";
export { ForwardRef as ReactComponent };